import { convertEntriesToUnitSystem } from '@contracts/measurements/convertEntriesToUnitSystem';
import { TripInformationFieldNames } from '@contracts/order/fields/TripInformationFields';
import type { OrderPermitApplicationResponse } from '@contracts/order/OrderResponse';
import type { PermitTypeUnit } from '@contracts/permitType/PermitType';
import { permitTypeUnit } from '@contracts/permitType/PermitType';
import type {
  AutofillEntryValue,
  PermitToPrefill,
} from '@extJurAutofill/externalPackagesContract/PermitToPrefill';

interface PermitToPrefillAttributes {
  permitId: string;
  targetUrl: string;
  permitType: string;
  fields: string[];
  unitSystem: PermitTypeUnit;
  entries: Record<string, AutofillEntryValue>;
  effectiveDate: string;
}

export const buildPermitToPrefill = ({
  permitId,
  targetUrl,
  permitType,
  fields,
  unitSystem,
  entries,
  effectiveDate,
}: PermitToPrefillAttributes): PermitToPrefill => {
  const isMetric = unitSystem !== permitTypeUnit.IMPERIAL;

  return {
    permitId,
    targetUrl,
    permitType,
    fields,
    unitSystem,
    entries: {
      ...convertEntriesToUnitSystem(entries, isMetric),
      [TripInformationFieldNames.EffectiveDate]: effectiveDate,
    },
  };
};

export const buildPermitToPrefillFromApplication = (
  permitApplication: OrderPermitApplicationResponse,
  fallbackTargetUrl: string,
): PermitToPrefill =>
  buildPermitToPrefill({
    permitId: permitApplication.id,
    targetUrl: permitApplication.permitTypeJurisdictionUrl ?? fallbackTargetUrl,
    permitType: permitApplication.permitType,
    fields: permitApplication.fields,
    unitSystem: permitApplication.unit,
    entries: permitApplication.entries,
    effectiveDate: new Date(permitApplication.effectiveDate).toISOString(),
  });

export const rebuildPermitToPrefill = (
  previous: PermitToPrefill,
  permitApplication: OrderPermitApplicationResponse,
): PermitToPrefill =>
  buildPermitToPrefillFromApplication(permitApplication, previous.targetUrl);
